import Swiper, { Manipulation, Navigation } from "swiper";

export default class ProperiesSearchSlider {
    constructor() {
        this.slider = document.querySelector('.js-properties-search-slider');
        this.errorContainer = document.querySelector('.js-properties-search-feedback');
        this.formTrigger = document.querySelector('.js-properties-search-form-trigger');
        this.loader = document.querySelector('.js-properties-search-spinner');
        this.form = document.querySelector('.js-property-search-form');

        if (this.form) {
            this.formSelect = this.form.querySelectorAll('select');
        }
        this.formData = { type: '', min_price: '', max_price: '', min_beds: '', max_beds: '' };
        this.swiper;

        this.bindEvents();
        this.init();
    }

    bindEvents() {
        this.form.addEventListener('change', e => {
            this.formData = this.parseForm();
            this.updateInputs();
            this.fetchProperties();
        });

        this.formTrigger.addEventListener('click', e => {
            this.formTrigger.classList.toggle('active');
            this.form.classList.toggle('active');
        });

        this.errorContainer.addEventListener('click', e => { 
            if (e.target.classList.contains('js-search-reset')) {
                this.form.reset();
                this.formData = this.parseForm();
                this.fetchProperties();
            }
        });
    }

    updateInputs() {
        let data = JSON.parse(this.formData);
        let max_price = this.form.querySelector('select[name="max_price"]');
        let max_beds = this.form.querySelector('select[name="max_beds"]');
        
        if (data.min_price > 0) {
            Array.from(max_price.options).forEach(o => { 
                if (o.value !== "" && o.value <= data.min_price) {
                    o.disabled = true;
                } else {
                    o.disabled = false;
                }
            });
        } else {
            Array.from(max_price.options).forEach(o => { o.disabled = false; })
        }

        if (data.min_beds > 0) {
            Array.from(max_beds.options).forEach(o => { 
                if (o.value !== "" && o.value < data.min_beds) {
                    o.disabled = true;
                } else {
                    o.disabled = false;
                }
            });
        } else {
            Array.from(max_beds.options).forEach(o => { o.disabled = false; })
        }        
    }

    fetchProperties() {
        this.setLoading(true);
        fetch("/wp-json/fabric/v1/properties", {
                method: "POST",
                body: this.formData,
                redirect: "follow"
            })
            .then((response) => response.json())
            .then((result) => this.updateSlider(result))
            .catch((error) => {
                this.errorContainer.innerHTML = `<div class="py-4">
                    Something went wrong, please try refreshing your browser.
                </div>`;
                this.setLoading(false);
            });
    }

    init() {
        this.swiper = new Swiper(this.slider, {
            modules: [Navigation, Manipulation],
            loop: false,
            spaceBetween: 8,
            slidesPerView: 1.15,
            allowTouchMove: true,
            threshold: 20,
            navigation: {
                nextEl: ".js-properties-slider-next",
                prevEl: ".js-properties-slider-prev",
            },
            breakpoints: {
                1024: {
                    slidesPerView: 3,
                }
            }
        });
    }

    updateSlider(result) {

        this.swiper.removeAllSlides();
        this.setLoading(false);

        if (result.posts) {
            this.errorContainer.innerHTML = "";

            result?.posts.forEach((post, i) => {
                this.swiper.addSlide(i, `
                    <div class="swiper-slide">
                        <div>
                            <a href="${post.url}" class="relative block">

                                ${post.sticker ? `
                                    <img data-src="${post.sticker.sizes.medium}" alt="${post.sticker.alt}" class="lazyload absolute top-0 right-0 mt-2 mr-2 z-10 w-20" />
                                    ` : ''
                                }      
                                
                                ${post.label != "" ? `
                                    <div class="absolute top-0 left-0 w-full z-2">
                                        <div class="font-medium text-xs uppercase h-7 px-2.5 inline-flex items-center text-center ${post.label_class}">
                                            ${post.label}
                                        </div>
                                    </div>                                    
                                    ` : ''
                                }      

                                <div class=" aspect-[15/10]">
                                    <img data-src="${post.thumbnail.url}" class="lazyload object-cover h-full w-full" alt="${post.thumbnail.alt}">
                                </div>
                            </a>
                            <div class="pt-5 pl-6 pr-3 lg:px-2 xl:px-6 pb-6">
                                <div class="text-sm font-light text-black mb-2">
                                    ${post.plots} ${post.plots > 1 ? 'plots' : 'plot'}
                                </div>
                                <h3 class="text-2xl font-light text-blue-700 mb-4">
                                    ${post.title}
                                </h3>
    
                                <div class="mb-5">
                                    ${post.bed_text != "" ? `
                                            <div class="text-sm font-light text-black flex items-center {{ bathroomsDetails ? 'mb-2' }}">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="14" fill="none" class="mr-4" viewbox="0 0 22 14"><path fill="#0F385B" d="M4.3 3.9c-.2 0-.4.2-.4.4v2h4.7v-2c0-.2-.1-.4-.3-.4h-4ZM2 13.6c0 .2.1.4.4.4h3.1c.2 0 .4-.2.4-.4v-1.2h-4v1.2Z"/><path fill="#0F385B" d="M3.1 4.3c0-.7.6-1.2 1.2-1.2h4c.6 0 1.1.5 1.1 1.2v2h3.2v-2c0-.7.5-1.2 1.1-1.2h4c.6 0 1.2.5 1.2 1.2v2h1.5V1.1C20.4.5 20 0 19.2 0H2.7c-.6 0-1.1.5-1.1 1.2v5H3v-2Z"/><path fill="#0F385B" d="M13.7 3.9c-.2 0-.3.2-.3.4v2H18v-2c0-.2-.2-.4-.4-.4h-4Zm2.4 9.7c0 .2.2.4.4.4h3.1c.3 0 .4-.2.4-.4v-1.2h-3.9v1.2ZM20.8 7H1.2C.5 7 0 7.5 0 8.2v3c0 .3.2.5.4.5h21.2c.2 0 .4-.2.4-.4V8.2c0-.7-.5-1.2-1.2-1.2Z"/></svg>
                                                <span>${post.bed_text}</span>
                                            </div>
                                       ` : ''
                                    }
                                    ${post.bath_text != "" ? `
                                        <div class="text-sm font-light text-black flex items-center">
                                            <svg class="mr-4" width="17" height="14" viewbox="0 0 17 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M16.494 5.28018H6.0856C6.04778 5.27104 6.00909 5.26618 5.97024 5.26569L3.03571 5.27811L3.04988 2.62767C3.0681 1.73521 3.59833 1.03533 4.26417 1.03533C4.99293 1.04271 5.60945 1.58852 5.72131 2.32535C5.75372 2.61125 6.00652 2.81613 6.28595 2.78297C6.56538 2.7498 6.76563 2.49115 6.73321 2.20525C6.56464 0.944572 5.51387 0.00374877 4.27024 0C3.05595 0 2.07643 1.14508 2.04405 2.61524L2.02381 5.28018H0.505952C0.226523 5.28018 0 5.51195 0 5.79785V6.66338C0.0027173 9.04203 1.62985 11.0952 3.90393 11.5895L2.90821 13.1798C2.79882 13.3351 2.78219 13.5396 2.86498 13.7113C2.94776 13.8831 3.11644 13.994 3.30351 13.9998C3.49058 14.0055 3.66548 13.9052 3.75821 13.7388L5.03929 11.6992H11.9607L13.2418 13.7388C13.3347 13.887 13.4948 13.9767 13.6668 13.977C13.8516 13.9766 14.0216 13.8732 14.1101 13.7072C14.1986 13.5411 14.1916 13.3389 14.0918 13.1798L13.0961 11.5895C15.3702 11.0952 16.9973 9.04203 17 6.66338V5.79785C17 5.51195 16.7735 5.28018 16.494 5.28018Z" fill="#0F385B"/>
                                            </svg>
                                            <span>${post.bath_text}</span>
                                        </div>
                                        ` : ''
                                    }                            
                                </div>
    
                                ${post.from_price != false ?
                                    `<div class='mb-6 text-lg text-black tracking-widest'>
                                        From <span class="font-medium">&pound;${post.from_price}</span>
                                    </div>` : ''
                                }
    
                                ${!post.from_price ? 
                                    `<div class='mb-6 text-lg text-black tracking-widest'>
                                        ${post.status}
                                    </div>`  : ''
                                }
                          
                                <div class="flex items-center">
                                    <a href="${post.url}" class="btn mr-8">
                                        <span>Discover</span>
                                        <svg width="8" height="12" viewbox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M-8.7738e-05 1.41L4.94464 6L-8.7738e-05 10.59L1.5222 12L8 6L1.5222 0L-8.7738e-05 1.41Z" fill="currentColor"/>
                                        </svg>
                                    </a>
                                    <a data-overlay="enquiry" data-development="{{ development }} - {{ title }}" class="js-overlay-open cursor-pointer font-bold text-sm text-blue-700">+
                                        <span class="underline">Enquire now</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>`
                )
            });
        } else {
            this.errorContainer.innerHTML = `<div class="py-4">
                No properties match your criteria, <button class='js-search-reset'>Click here</button> to reset your search.
            </div>`;
        }
    }

    setLoading (status) {
        if (status) {
            this.slider.classList.add('loading');
            this.errorContainer.classList.add('loading');
            this.loader.classList.add('loading');
        } else {
            this.errorContainer.classList.remove('loading');
            this.slider.classList.remove('loading');
            this.loader.classList.remove('loading');
        }
    }

    parseForm() {
        const formData = new FormData(this.form);
        return JSON.stringify(Object.fromEntries(formData));
    }
}

new ProperiesSearchSlider;